import type { FaireProductEntity } from "../../entity_types/product";

export const p_u7bfnkftvh: FaireProductEntity = {
  token: "p_u7bfnkftvh",
  type: "product",
  name: "Women’s Long Open Front Knit Cardigan",
  brandToken: "b_3eopd3scey",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/74d4876f40d9c9a7ced216e94731169d27954254a603e031df57fefc2263b219.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/346b3ff961c1abe5c85acabb91e245bcc4a2514f249e385a704b26f5c4dc9f07.jpeg",
    "https://cdn.faire.com/fastly/c4a577886a549a80c569d546b3d6e5c6078fbe0945355d414f296c65b0084956.jpeg",
    "https://cdn.faire.com/fastly/6c37d22dfaf721fc3f969ec552779148f7b437f4427ebcd5bf86bf3fd62803d0.jpeg",
    "https://cdn.faire.com/fastly/3daaa230bf1da62c8b8efd207e7efbb3b605331916862360fc2242d2e88a537d.png",
    "https://cdn.faire.com/fastly/ae6428bc65d0ce8aab08a70cff0c9cd03fbdf0581ead5d6f30f5f1e765d0bff4.jpeg",
    "https://cdn.faire.com/fastly/31c5f3e9819ce5105985a74ffb41edd5408710dbe925e070a870ab7ff1abf041.jpeg",
    "https://cdn.faire.com/fastly/56d4f7661a294316a36248be473656035aefca86cfb40b11ce88d2060cdd5108.jpeg",
    "https://cdn.faire.com/fastly/7d50859f07abcea32adfc121bb9942080a3cd825ec060cccd614a402397b714b.jpeg",
    "https://cdn.faire.com/fastly/67f2038b563cdedfdf6765a6d9111520f8fdc7f3f592315e464c69517c121cf9.jpeg",
    "https://cdn.faire.com/fastly/1b17193f19951354bdb47d957ac560ca556d5347167981bcb149aa8c64704ecc.jpeg",
    "https://cdn.faire.com/fastly/d5f159d33e040d70ccd40c7034d40ccd5fd92a83185ff37cd8d586a4a413ffb3.jpeg",
    "https://cdn.faire.com/fastly/19a0231c96dacd8492e6eb25d045232cbba3c5b16175d50215f0e948a20db5d1.jpeg",
    "https://cdn.faire.com/fastly/c9cbb741ee5295698eea7b9944175643b6beecffab6ac4f3cc0a014ecbf3a0bd.jpeg",
    "https://cdn.faire.com/fastly/8b3cd767fc83493f9eb860a3e6f18aaefccf5e739d57a884c869f220de0e2147.jpeg",
    "https://cdn.faire.com/fastly/76025333292b74b6b5744c14aa4a1425a63edd3ead6a3b354fa1c2692fae89b9.jpeg",
  ],
  priceDollars: 16.63,
  description:
    "97%POLYESTER. 3%SPANDEX\nSIZE  S / M / L / XL\nMADE IN CHINA\n\nWOMEN BLAZER, CROCHET CARDIGAN, CABLE KNIT SWEATER, RUFFLE DRESS, EYELET BLOUSE, PUFF SLEEVE TOP, DENIM SKIRTS, DENIM SHORTS, RIPPED JAENS, RIPPED JEANS, MAXI SKIRT, JUMPSUIT, CROP TOP, SHORT SLEEVE, SHOLESALE SHIRTS, PLAIS SHIRT, WOMEN SHORTS, PANTS, BOHEMIAN, BOHO, WINTER BLOUSE, WINTER SHIRT, WESTERN, BEST SELLING, PROMOTION, TRENDING, NEW PRODUCTS, ACTIVEWEAR, COSTUMES, UNIFORMS, JUMPSUITS, LOUNGEWEAR, SLEEPWEAR NIGHTWEAR, SWEATSHIRTS, HOODIES, TANK TOPS, CHRISTMAS, HOT SELLING ",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:37.523Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
